import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { isEmbed, ROUTE_PATH } from 'routes';
import { useNavigate } from 'react-router-dom';
import { Button } from 'xland-ui';
import { useSelector } from 'react-redux';
import './styles.scss';

function ErrorLayout({ code = 500, onNavigate = null }) {
  const literals = useSelector(state => state.i18n.literals.errors);
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path, { replace: true });
    if (onNavigate) {
      onNavigate(path);
    }
  };

  const error = useMemo(() => {
    switch (code) {
      case 401:
        return { code: 401, text: literals.unauthorized };
      case 403:
        return { code: 403, text: literals.forbidden };
      case 404:
        return { code: 404, text: literals.notFound };
      default:
        return { code: 500, text: literals.internalError };
    }
  }, [code, literals]);

  return (
    <div className='error-layout'>
      <div>
        <h1>{error.code}</h1>
        <div className='content'>
          <h2>{error.text}</h2>
        </div>
      </div>
      {!isEmbed() && (
        <div className='buttons-left mt-lb'>
          <Button
            text={literals.goHome}
            variant='tertiary'
            onClick={() => handleNavigate(ROUTE_PATH.PREHOME)}
          />
          <Button
            text={literals.goBack}
            onClick={() => handleNavigate(-1)}
          />
        </div>
      )}
    </div>
  );
}

ErrorLayout.propTypes = {
  code: PropTypes.number.isRequired,
  onNavigate: PropTypes.func,
};

export default ErrorLayout;
